// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T_dB","col":"styles_col__2-74U"};